module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kp-no-page"
  }, [_c('div', {
    staticClass: "no-page-content"
  }, [_c('div', {
    staticClass: "empty_state_logo"
  }, [_c('svg', {
    staticClass: "empty_state_svg",
    attrs: {
      "width": "28",
      "height": "28",
      "viewBox": "0 0 28 28",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M28 25V3C28 1.375 26.625 0 25 0H3C1.3125 0 0 1.375 0 3V25C0 26.6875 1.3125 28 3 28H25C26.625 28 28 26.6875 28 25ZM3 26C2.4375 26 2 25.5625 2 25V3C2 2.5 2.4375 2 3 2H25C25.5 2 26 2.5 26 3V25C26 25.5625 25.5 26 25 26H3ZM16 8.5V7.5C16 7.25 15.75 7 15.5 7H6.5C6.1875 7 6 7.25 6 7.5V8.5C6 8.8125 6.1875 9 6.5 9H15.5C15.75 9 16 8.8125 16 8.5ZM22 14.5V13.5C22 13.25 21.75 13 21.5 13H6.5C6.1875 13 6 13.25 6 13.5V14.5C6 14.8125 6.1875 15 6.5 15H21.5C21.75 15 22 14.8125 22 14.5ZM12 20.5V19.5C12 19.25 11.75 19 11.5 19H6.5C6.1875 19 6 19.25 6 19.5V20.5C6 20.8125 6.1875 21 6.5 21H11.5C11.75 21 12 20.8125 12 20.5Z",
      "fill": "#464B52"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "empty_state_text-content"
  }, [_c('div', {
    staticClass: "empty_state_title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('empty.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "empty_state_subtitle"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('empty.subtitle')))])])]), _vm._v(" "), (_vm.topBarConfig.user.ucode === true) ? _c('a', {
    staticClass: "empty_state_link",
    attrs: {
      "href": _vm.$t('empty.urlExtensions')
    }
  }, [_vm._v(_vm._s(_vm.$t('empty.link'))), _c('span', {
    staticClass: "icon-kp-external"
  })]) : _c('a', {
    staticClass: "empty_state_link",
    attrs: {
      "href": _vm.$t('empty.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('empty.link'))), _c('span', {
    staticClass: "icon-kp-external"
  })]), _vm._v(" "), _c('div', {
    staticClass: "empty-btn"
  }, [_c('a', {
    staticClass: "empty_state_button",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.boxAdd()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('empty.button')))])])])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-7d0bac99!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/Empty.vue
 ** module id = 873
 ** module chunks = 1
 **/